var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 71 71"}},[_c('circle',{attrs:{"cx":"35.5","cy":"35.5","r":"35.5","fill":"#00ffdc"}})])}
var staticRenderFns = []

export { render, staticRenderFns }